import React, { useRef, useEffect, Fragment, useState } from 'react';
import IntlMessages from 'util/IntlMessages';
import Loading from 'util/loading';
import {
  Box,
  Button,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Card,
  CardContent,
  Alert,
  Snackbar,
  FormHelperText,
} from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Search, Close } from '@mui/icons-material';
import { API } from 'aws-amplify';
import config from './config.json';

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

// de 1 a 12
const months = [...Array(12).keys()].map((i) => i + 1);

const styles = {
  controlBar: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  operatorSelect: {
    minWidth: 250,
  },
  card: {
    marginTop: 1,
  },
};

const NxAccessPage = (params) => {
  const [loading, setLoading] = useState(false);
  const mounted = useRef(null);
  const [operators, setOperators] = useState([]);

  const [currentOperatorId, setCurrentOperatorId] = useState('');
  const [cardContents, setCardContents] = useState('');

  const [selectedDate, setSelectedDate] = useState(null);

  const [alert, setAlert] = useState({
    severity: 'info',
    message: '',
    open: false,
  });

  useEffect(() => {
    mounted.current = true;

    listOperators();

    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  async function listOperators() {
    try {
      setLoading(true);
      const apiName = 'lambdaApi';
      const path = '/listNxOperators';
      const response = await API.get(apiName, path);
      console.log(response);
      setOperators(response.sort(compareOperators));
    } catch (error) {
      console.log(error);
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
    } finally {
      setLoading(false);
    }
  }

  function plain(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  const compareOperators = function (a, b) {
    if (plain(a.name) > plain(b.name)) return 1;
    if (plain(a.name) < plain(b.name)) return -1;
    return 0;
  };

  function handleCloseAlert() {
    setAlert({
      message: '',
      severity: 'info',
      open: false,
    });
  }

  function handleChangeOperator(e) {
    console.log(e.target.value);
    setCurrentOperatorId(e.target.value);
  }

  function handleChangeDate(aEvent) {
    console.log(aEvent.target.value);
    setSelectedDate(aEvent.target.value);
  }

  async function scan() {
    try {
      setLoading(true);

      const response = await fetch(
        `${config.host}/activities/provider/${currentOperatorId}`,
        //`${config.host}/activities/count/provider/5000`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${config.token}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Não encontrado na NX');
        } else {
          throw new Error(response.statusText);
        }
      }

      const body = await response.json();
      console.log(body);
      setCardContents(body);
    } catch (error) {
      console.log(error);
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Fragment>
      <Card sx={styles.card}>
        <CardContent>
          <Box sx={styles.controlBar}>
            <FormControl required variant="standard">
              <InputLabel>
                <IntlMessages id="neo.operators.single" />
              </InputLabel>

              <Select
                name="currentOperator"
                value={currentOperatorId}
                onChange={(e) => handleChangeOperator(e)}
                variant="standard"
                sx={styles.operatorSelect}
              >
                {operators.map((op, idx) => (
                  <MenuItem key={idx} value={op.id}>
                    {op.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Id NX: {currentOperatorId}</FormHelperText>
            </FormControl>

            <FormControl variant="standard">
              <InputLabel>Mês</InputLabel>

              <Select
                name="selectedDate"
                value={selectedDate}
                onChange={(e) => handleChangeDate(e)}
                variant="standard"
                sx={styles.operatorSelect}
              >
                {months.map((item, idx) => (
                  <MenuItem key={idx} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>

              {/* <DatePicker
                label={'Mês'}
                views={['month']}
                value={selectedDate}
                onChange={(newValue) => handleChangeDate(newValue)}
              /> */}
            </FormControl>

            <Button
              variant="contained"
              color="primary"
              disabled={currentOperatorId.length === 0 || selectedDate === null}
              onClick={() => scan()}
              endIcon={<Search />}
            >
              Pesquisar
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" align="left">
            {cardContents}
          </Typography>
        </CardContent>
      </Card>

      <Loading loading={Boolean(loading)} />

      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={handleCloseAlert}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Alert severity={alert.severity}>{alert.message}</Alert>
      </Snackbar>
    </Fragment>
  );
};

export default NxAccessPage;
